var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-config-provider',{attrs:{"get-popup-container":_vm.getPopupContainer,"locale":_vm.locale},on:{"click":_vm.getPopupContainer}},[_c('ys-provider',{attrs:{"api":_vm.providerApi,"search-form":_vm.searchForm}},[_c('div',{staticClass:"h-full overflow-auto",attrs:{"id":"app"}},[_c('router-view')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }